export default "__VITE_ASSET__0040c600__"